import { Component, HostListener, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ME_Fit } from 'me-fit-typings';

/**
 * Value editor for WorkoutStep that is optimised for mobile devices.
 */
@Component({
  selector: 'me-value-editor',
  templateUrl: './value-editor.component.html',
  styleUrls: ['./value-editor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ValueEditorComponent),
      multi: true,
    },
  ],
})
export class ValueEditorComponent implements ControlValueAccessor {
  @Input({required: true}) valueType: ME_Fit.WorkoutStepType;

  @Input() showLabel = true;

  @Input() placeholder: string|number|undefined;

  @Input() min = 0;

  formCtrl = new FormControl<number>(0);

  private onTouchedCallback: () => void;

  @HostListener('focusout')
  async onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: number): void {
    this.formCtrl.setValue(value);
  }

  registerOnChange(fn: (value: number) => void): void {
    this.formCtrl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formCtrl.disable() : this.formCtrl.enable();
  }

}
